import { AppSidebar } from "@/components/app-sidebar";
import { MainNav } from "@/components/main-nav";
import { TailwindIndicator } from "@/components/tailwind-indicator";
import { ThemeToggle } from "@/components/theme-toggle";
import { siteConfig } from "@/config/site";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import {
	Separator,
	SidebarInset,
	SidebarProvider,
	SidebarTrigger,
} from "shadcn-ui";
import { useAuth } from "@/lib";
import { auth } from "@/lib";

export const Route = createFileRoute("/_app")({
	beforeLoad: async ({ context, location }) => {
		// Use Better Auth client from router context to validate session
		const { data, isPending } = context.auth ?? { data: null, isPending: true };
		// Avoid redirecting while the auth client is still hydrating
		if (isPending) return;

		let user = (data as any)?.user;
		// If no user yet, force a session fetch once before redirecting
		if (!user) {
			try {
				const refreshed = await auth.getSession();
				user = (refreshed as any)?.data?.user;
			} catch {}
		}

		if (!user) {
			console.log('[/_app] beforeLoad: No session, redirecting to /login');
			throw redirect({
				to: '/login',
				search: {
					redirect: location.href,
				},
			});
		}
	},
	component: AppComponent,
});

function AppComponent() {

	useAuth()

	return (
		<SidebarProvider defaultOpen>
			<AppSidebar />
			<SidebarInset>
				<header className="bg-background sticky inset-x-0 top-0 isolate z-10 flex shrink-0 items-center gap-2 border-b">
					<div className="flex h-14 w-full items-center gap-2 px-4">
						<SidebarTrigger className="-ml-1.5" />
						<Separator
							orientation="vertical"
							className="mr-2 data-[orientation=vertical]:h-4"
						/>
						<MainNav />
						<div className="ml-auto flex items-center gap-2">
							<ThemeToggle />
						</div>
					</div>
				</header>

				<Outlet />
				{/* {import.meta.env.DEV && <TailwindIndicator />} */}
			</SidebarInset>
		</SidebarProvider>
	);
}
